// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.bs.js");

var Models = /* module */[];

function campus(json) {
  return /* record */[
          /* id */Json_decode.field("id", Json_decode.string, json),
          /* name */Json_decode.field("name", Json_decode.string, json),
          /* archive_link */Json_decode.field("archive_link", Json_decode.string, json)
        ];
}

function item(json) {
  return /* record */[
          /* date */Json_decode.field("date", Json_decode.string, json),
          /* link */Json_decode.field("link", Json_decode.string, json),
          /* title */Json_decode.field("title", Json_decode.string, json),
          /* campus */Json_decode.field("campus", (function (param) {
                  return Json_decode.optional(campus, param);
                }), json),
          /* editorialTitle */Json_decode.field("editorialTitle", Json_decode.string, json),
          /* editorialId */Json_decode.field("editorialId", Json_decode.$$int, json),
          /* editorialLink */Json_decode.field("editorialLink", Json_decode.string, json),
          /* thumb */Json_decode.field("thumb", Json_decode.string, json)
        ];
}

function new_(json) {
  return /* record */[
          /* label */Json_decode.field("label", Json_decode.string, json),
          /* items */Json_decode.field("items", (function (param) {
                  return Json_decode.list(item, param);
                }), json)
        ];
}

function editorial(json) {
  return /* record */[
          /* id */String(Json_decode.field("id", Json_decode.$$int, json)),
          /* label */Json_decode.field("label", Json_decode.string, json)
        ];
}

function campus$1(json) {
  return /* record */[
          /* id */Json_decode.field("id", Json_decode.string, json),
          /* label */Json_decode.field("label", Json_decode.string, json)
        ];
}

function filters(json) {
  return /* record */[
          /* editorials */Json_decode.field("editorials", (function (param) {
                  return Json_decode.list(editorial, param);
                }), json),
          /* campi */Json_decode.field("campi", (function (param) {
                  return Json_decode.list(campus$1, param);
                }), json)
        ];
}

function response(json) {
  return /* record */[
          /* news */Json_decode.field("news", (function (param) {
                  return Json_decode.list(new_, param);
                }), json),
          /* filters */Json_decode.field("filters", filters, json)
        ];
}

var Decode = /* module */[
  /* item */item,
  /* new_ */new_,
  /* editorial */editorial,
  /* campus */campus$1,
  /* filters */filters,
  /* response */response
];

exports.Models = Models;
exports.Decode = Decode;
/* No side effect */
